import { RefObject, useEffect } from 'react';

interface Props {
  target: RefObject<HTMLElement>;
  root?: HTMLElement;
  rootMargin?: string;
  threshold?: number;
  onIntersect: IntersectionObserverCallback;
}

export const useObserver = ({
  target,
  root,
  rootMargin = '0px',
  threshold = 1.0,
  onIntersect,
}: Props) => {
  useEffect(() => {
    let observer: IntersectionObserver;

    if (target && target.current) {
      observer = new IntersectionObserver(onIntersect, {
        root,
        rootMargin,
        threshold,
      });
      observer.observe(target.current);
    }
    return () => observer && observer.disconnect();
  }, [target, rootMargin, threshold, onIntersect, root]);
};
